import { logIn } from "ionicons/icons";

// logIn.tsx
export const SKIP_FOR_NOW = "SKIP FOR NOW";
export const BOOK_CAR_SERVICE = "Book Car Service";
export const BEST_CAR_SERVICE =
	"The best car service centers in UAE with real-time tracking of your vehicle";
export const EXCITING_REWARDS = "Exciting Rewards";
export const REWARDING_TEXT = "Now Its Rewarding To Keep Your Car In Top Shape.";
export const DOCUMENT_VAULT = "Document Vault";
export const DOCUMENT_VAULT_TEXT =
	"Your Car Is In Safe Hands: Find The Right Service At The Right Price From The Best Repairers";
export const QUALITY_SERVICE = "Quality Service";
export const QUALITY_SERVICE_TEXT =
	"Assured Quality service standards that were never seen before.";
export const CONVENIENCE = "Convenience";
export const CONVENIENCE_TEXT = "Hassle-free experience powered by advanced technology";
export const CERTIFIED_TECHNICIANS = "Certified Technicians";
export const CERTIFIED_TECHNICIANS_TEXT =
	"Technicians who are professionally trained and certified as per standards.";
export const LOGIN_OR_SIGNUP = "Login/Sign Up";
export const MOBILE_NUMBER = "Mobile Number";
export const OTP_TEXT = "A One Time Password (OTP) will be sent to your phone number";
export const CONTINUE = "Continue";
export const MY_CART = "My Cart";

export const CONTINUE_USING_MOBILENUM = "Continue using Mobile Number";
export const OR_LOGIN_WITH = "or Login with";
export const OR = "or";
export const GOOGLE = "Google";
export const FACEBOOK = "Facebook";
export const APPLE = "Apple";
export const BY_CONTINUE = "By continuing, you agree to our";
export const T_AND_C = "T&C";
export const PRIVACY_POLICY = "Privacy Policy";
export const GET_THE_APP = "Download to unlock rewards";
export const TERMS_AND_CONDITIONS_CAP = "TERMS & CONDITIONS *";
export const GOOGLE_PLAY_STORE_LINK =
	"https://play.google.com/store/apps/details?id=com.tserv.software";
export const APPLE_APP_STORE_LINK =
	"https://apps.apple.com/us/app/t-serv-total-car-service/id1619335263";
export const IMPORTANT = "IMPORTANT:";
export const T_AND_C_TEXT = `The following Terms and Conditions (in addition to the documents referred to in them) govern your use of our website and its related sites, services, applications, and tools. Carguys.ae, you confirm that you both understand these Terms and Conditions and that you agree to abide by them. Please read the Terms carefully and if you do not accept the Terms, do not use the Website.

We may need to change the Terms from time to time for a number of reasons (including to comply with applicable laws and regulations, and regulatory requirements). Any minor or insubstantial changes may be made at any time and you are advised to review the Terms on a regular basis. The most up to date Terms will be available on the Website. All major changes will be notified to you in advance of such changes taking effect. If any change is unacceptable to you, you should cease using the Website and/or close your account. If, however, you continue to use the Website after the date on which the changes to the Terms come into effect, you will be deemed to have accepted those changes.

Reference to “you”, “your” or the “customer” is reference to any person using the Website or the services of carguys.ae or any registered customer of  carguys.ae. United Arab of Emirates is our country of domicile. We will not trade with or provide any services to OFAC and sanctioned countries. Customer using the website who are Minor /under the age of 18 shall not register as a User of the website and shall not transact on or use the website. The Cardholder must retain a copy of transaction records and Merchant policies and rules. You as the User are responsible for maintaining the confidentiality of your account.
-About Carguys.ae
carguys.ae (referred to as “Service My Car”) is a website operated by SMC Auto Service Broker LLC, registered in Dubai by Department Of Dubai Economic Development under license number 809649. The registered address is PO Box 333761 in Dubai, United Arab Emirates.

-Vehicle Servicing Online
All our service packages online are based on service and labor charges only and do not include any parts cost. Parts cost will be additional and will be agreed and paid in full by the customer after completion of the service but prior to the vehicle delivery.

-Collection & Delivery
Our free collection and delivery service is a service where either Service My Car or one of our approved service agents will collect and deliver your vehicle to you for free when you purchase any service package online. The driver will arrive at the agreed location you provide at the time of placing the booking and will carry out and onsite inspection / damage report which once checked you must sign to confirm. This report will then be sent to you via email and SMS to the information you provided upon registration on carguys.ae.

Please ensure you remove all your valuables and belongings before handing over your vehicle to our driver as we will take no liability on any missing items . Your vehicle will go through multiple departments involving a third party workshop. Although our workshops can be trusted we cannot accept any liability for missing items .
-Payment
Payment Must be made online to secure your booking using our secure payment gateway. At the time of the booking we will only charge you for the service package. Please remember our service packages do not include parts and these incur an additional cost. Once the free vehicle health check has been carried out we will then send you the price for the parts and the price for any additional work your car requires. The service parts must be paid for but the additional work is your choice. You are free to repair your vehicle elsewhere. Visa or MasterCard debit and credit cards in AED, SAR, OMR & QAR will be accepted for payment

Once the payment is made, the confirmation notice will be sent to the client via email within 24 hours of receipt of payment.

-Vehicle Parts
for parts you have two options at the time of booking.

Option one is that you supply your own parts, If you choose this option then please leave the parts in the vehicle on the day of the service. Please also remember with option one we cannot offer any form of warranty or guarantee for the parts you supply, we can only offer labor warranty for any service or repair work we carry out on your vehicle.

Option two is that you buy your parts from Car Guys Auto Services. We will provide you with either Genuine parts or aftermarket parts according to your affordability and budget. We recommend you install genuine parts on your vehicle as the manufacturers recommend.

Any special-order parts will require payment in advance. The parts will be ordered from the parts suppliers and the order will be nonrefundable.
The shipment of the special order parts may be delayed from the given expected delivery date due to third party logistics. Once the parts arrive you will be Notified.

-Law & Jurisdiction
Every service contract with us will be governed by UAE law and any dispute or claim arising out of or in connection with it shall be subject to the exclusive jurisdiction of the courts of the United Arab Emirates unless the physical inspection of the car takes place in a different country, in which case it will be governed by that respective country’s law and any dispute or claim arising out of or in connection with it shall be subject to the exclusive jurisdiction of the courts of the country we operate in.
-Privacy Policy
Please view our privacy policy page. Our Privacy Policy can be found at Privacy Policy
-Allowed use
The access and use of this website is only allowed for your personal, non-commercial purposes. This means this website may only be accessed and used directly by a private individual. It is strictly prohibited to access and use this website for anything other than for your personal, non-commercial purposes.

The use of this website:

In any unlawful, fraudulent or commercial manner
To create, check, confirm, update, modify or amend your own or another person’s databases, records or directories
Using any automated software, process, program, robot, web crawler, spider, data mining, trawling or other ‘screen scraping’ software, process, program or system is not permitted.
You are allowed to operate a link to this website provided you do so in a way that is fair and legal and does not damage our reputation or take advantage of it, as determined by us.

To operate a link to this website in such a way as to suggest or imply any form of association, approval or endorsement by us is not permitted.

We reserve the right to require you to immediately remove any link to this website at any time and we may withdraw any linking permission at any time.

-Speeding Fines & Accidents
From the time we collect your car to the time we deliver your car Service My Car and their Service Agents are responsible for any parking, speeding and any traffic fines. We are also responsible for any road traffic accidents that take place while your vehicle is in the possession of Service My Car or one of its agents. Any traffic fines will be reimbursed after investigation. Please email Fines@ carguys.ae and one of our advisors will contact you. In the event of an accident Service My Car or one of the agents will claim with the insurance company and if the vehicle is deemed a write off or not drivable then a replacement hire car will be provided for a maximum of two weeks (14 days) at no cost to you.

-Our Contact
Email at service@ carguys.ae

Accounts at accounts@ carguys.ae

Mobile No: 00971-55-5031298

- Refunds & Cancellations
Refunds and cancellations will only be allowed before seven days of the service date. If you cancel anytime under seven days leading up to your service date then no refund will be provided. For cancellations and refunds please email accounts@carguys.ae with the subject field as refund and cancellation along with your name and vehicle registration.

Example:

REFUND AND CANCELLATION –

Mohammad – X 12345

Refunds will be made onto the original mode of payment and will be processed within 10 to 45 days depends on the issuing bank of the credit card

Refunds will not be allowed on any promotional offers.

SERVICE CONTRACTS TERMS AND CONDITIONS FOR CANCELLATIONS AND REFUNDS
During the first three months only a maximum of 50% will be refunded at the sole discretion of Car Guys Auto Services if no services have been utilized.

If services have been utilized then you cannot cancel the contract and no refund will be provided.

After 3 months all service contracts are non refundable until they expire.

VAT
All prices online and in quotations are excluding the government VAT at a rate of 5% as per the United Arab Emirates law. The vat will be applied to the final invoice .

Cookies
We collect standard internet log information and details of visitor behavior patterns through The use of cookies when you visit  carguys.ae. We do this to find out things such as the number of visitors to the various parts of the site. We collect this information anonymously. We will not associate any data gathered from this site with any personally identifying information from any source.

This page tells you the terms and conditions on which we service your vehicle for you. Before placing a booking please read the conditions thoroughly. You agree to be bound by the conditions listed above.

`;

//otp.tsx
export const GET_STARTED = "Get Started";
export const ENTER_SIX_DIGIT_OTP = "Enter 6 Digit OTP";
export const RESEND_OTP_IN = "Resend OTP in";
export const SUBMIT = "Submit";
export const REENTER_MOBILE_NO = "Change mobile no ?";
export const OTP_HAS_BEEN_SENT =
	"A One Time Password (OTP) has been sent to +971 **** ***99, Please enter it";

//personalDetails.tsx
export const EDIT = "Edit";
export const BOOK_A_SERVICE = "Book a Service";
export const MY_BOOKINGS = "My Bookings";
export const REWARDS_OR_OFFERS = "Rewards/Offers";
export const ABOUT_AUTOROX = "About CarGuys";
export const ABOUT_PETROMIN = "About Petromin Express";
export const ABOUT_TSERV = "About TSERV";
export const ABOUT_VALUE_PLUS = "About ValuePlus";
export const DOWNLOAD_OUR_APP = "Download our app";
export const INSTALL_APP_AND_GET_DISCOUNT =
	"Install app now and get 10% discount coupon instantly";
export const PERSONAL_DETAILS = "Personal Details";
export const NAME = "Name";
export const EMAIL_ADDRESS = "Email Address";
export const DOB = "Date Of Birth";
export const GENDER = "Gender";
export const ADD_VEHICLE = "Add Vehicle";
export const BRAND = "Brand";
export const MODEL = "Model";
export const SELECT_YEAR = "Select Year";
export const FUEL_TYPE = "Fuel Type";
export const VARIANT = "Variant";
export const EMPTY_CART = "Your Cart is empty";
export const HOME = "Home";
export const MY_PROFILE = "My Profile";
export const PROFILE_COMPLETION = "Profile Completion";
export const PROFILE_DETAILS = " Personal Details";
export const PROFILE_VEHICLES = "My Vehicles";
export const MY_ADDRESS = "My Addresses";
export const COUNTRY_CODE = " +971";
export const COUNTRY_CODE_PREFIX = "971";
export const CLIENT_NAME = "CarGuys";

//Dashboard.tsx
export const ADD_A_NEW_VEHICLE = "Add a new vehicle";
export const MY_DASHBOARD = "My Dashboard";
export const SERVICE_STATUS = "Service Status";
export const YOU_DONT_HAVE_ACTIVE_SERVICES = "You don’t have any Active Services";
export const OVER_2K_PLUS =
	"Over 2k+ people utilized our premium services and over 10K+ people utilized standard services";
export const LAST_SERVICE = "Last Service";
export const NEXT_SERVICE = "Next Service";
export const ODOMETER = "Odometer";
export const RECOMMENDED_SERVICES = " Recommended Services";
export const YOU_DONT_HAVE_ANY_VEHICLES_ADDED = "You don’t have any vehicles added";
export const TO_SEE_LIST_OF_RECOMMENDED_SERVICES = "to see list of recommended services";
export const FLAT = "Flat";
export const SAVE_UP_TO = "Save up to";

export const DISCOUNT = "Discount";
export const USE_CODE = "Use Code : ";
export const NO_ACTIVE_SERVICES_AVAILABLE = "No active services available";
export const VALID = "Valid till: ";

//MyAddresses.tsx
export const DELETE = "Delete";
export const MAKE_DEFAULT = "Make Default";
export const ADD_NEW_ADDRESS = "Add New Address";
export const SAVED_ADDRESS = "Saved Addresses";
export const NO_SAVED_ADDRESS = "No Saved Addresses";

//AddVehicle.tsx
export const SELECT_VEHICLE_BRAND = "Select vehicle brand";
export const SELECT_VEHICLE_MODEL_YEAR = "Select vehicle model";
export const SEARCH_VEHICLE_MODEL_YEAR = "Search vehicle model";
export const SELECT_VEHICLE_VARIANT = "Select vehicle variant";
export const SEARCH_VEHICLE_VARIANT = "Search vehicle variant";
export const SEARCH_FOR_VEHICLE = "Search for vehicles";
export const SEARCH_FOR_BRANDS = "Search for brands";
export const BRAND_PLACEHOLDER = "Select Brand, Eg: Honda";
export const MODEL_PLACEHOLDER = "Select Model, Eg: Honda City";
export const VARIANT_PLACEHOLDER = "Select Variant, Eg: Honda City VX CVT";
export const MY_VEHICLES = "My Vehicles";
export const DEFAULT = "Default";
export const ADD_ANOTHER_VEHICLE = "Add another vehicle";
export const CHOOSE_FROM = "Choose from";
export const THREE_THOUSAND_PLUS = " 3000+";
export const MODELS = "models";
export const MANAGE_YOUR_VEHICLE = " Manage your Vehicle";
export const HONDA_CITY = "Honda City";
export const YEAR_DIESEL = "2017,Diesel";
export const NICK_NAME = " Nick Name";
export const VIN_NUMBER = "VIN NUMBER";
export const DEFAULT_LOCATION = "Default Location:";
export const CHANGE = "Change";
export const SAVE_AND_UPLOAD_DOCUMENT = "Save and Upload Documents";

//Header.tsx
export const SELECT_YOUR_VEHICLE = "Select your vehicle";
export const TEN = "10";
export const CITY_4334 = "City 4334";
export const SIGN_OUT = " Sign Out";
export const ENTER_YOUR = "Please enter your ";
export const CONNECTED_USING = "Connected using";

export const SAVE = "Save";
export const RESEND_OTP = "Resend OTP";

//DocumentVault.tsx
export const VIRTUAL_RC = "Virtual RC";
export const UPLOAD = "Upload";
export const REG_NO = "Registration Number";
export const CHASSIS_NO = "Chassis No.";
export const EXPIRY_DATE = "Expiry Date";
export const ENGINE_NO = "Engine No.";
export const VIRTUAL_INSURANCE = "Virtual Insurance";
export const INSURER = "Insurer";
export const VIRTUAL_PUCC = "Virtual PUCC";
export const POLICY_NO = "Policy No.";
export const PUCC_NO = "PUCC No.";

//addDocuments.tsx
export const ENTER_YOUR_FULL_NAME_HERE = "Enter your vehicle registration number";
export const REGISTRATION_NUMBER = "Enter Your Vehicle Registration Number"; //"AP 29 AA 1234";

export const ENTER_YOUR_EMAIL = "Enter your vehicle chassis number";
export const DATE = "Date";
export const MONTH = "Month";
export const YEAR = "Year";
export const IMAGES = "Images";
export const FORMATS_ACCEPTED = "PDF, JPG, PNG are currently supported";
export const UPLOAD_FRONT = "Upload Front";
export const UPLOAD_BACK = "Upload Back";
export const DOCUMENT = "Document";

//addInsurance.tsx
export const ADD_VIRTUAL_INSURANCE = "Add Virtual Insurance";
export const INSURANCE_COMPANY = "Insurance Company";
export const ENTER_INSURANCE_COMPANY_NAME = "Enter insurance company name";
export const ENTER_POLICY_NUMBER = "Enter policy number";

//addPUCC.tsx
export const ADD_VIRTUAL_PUCC = "Add Virtual PUCC";
export const PUCC_NUMBER = "PUCC No.";
export const ENTER_PUCC_NUMBER = "Enter PUCC number";

//addNewAddress.tsx
export const CURRENT_LOCATION = "Current Location";
export const USING_GPS = "Using GPS";
export const SELECT_YOUR_ADDRESS = "Select your Address";

//alerts.tsx
export const PLEASE_ENTER_VALID_MOBILE_NUMBER = "Please enter valid mobile number";
export const PLEASE_SELECT_BRAND = "Please select brand";
export const PLEASE_SELECT_MODEL = "Please select model";
export const PLEASE_SELECT_FUEL_TYPE = "Please select fuel type";
export const PLEASE_SELECT_VARIANT = "Please select variant";
export const PLEASE_ENTER_VALID_OTP_NUMBER = "Please enter valid otp number";
export const PLEASE_ENTER_NAME = "Please enter name";
export const PLEASE_ENTER_VALID_NAME = "Please enter valid name";
export const PLEASE_ENTER_VALID_EMAIL = "Please enter valid email";
export const PLEASE_SELECT_THE_GENDER = "Please select the gender";
export const PLEASE_SELECT_DOB = "Please select date of birth";
export const SAVED_SUCCESSFULLY = "Saved Successfully";
export const ADDRESS_SAVED_SUCCESSFULLY = "Address Saved Successfully";
export const PLEASE_ENTER_HOUSE_FLAT_NO = "Please enter House/Flat no.";
export const PLEASE_ENTER_LANDMARK = "Please enter landmark.";
export const PLEASE_SELECT_CITY = "Please enter valid city.";
export const PLEASE_SELECT_STATE = "Please enter valid state.";
export const PLEASE_ENTER_PINCODE = "Please enter valid pincode.";
export const PLEASE_SELECT_ADDRESS_TYPE = "Please select address type.";
export const PLEASE_ENTER_REGISTRATION_NUMBER = "Please enter registration number";
export const PLEASE_ENTER_CHASSIS_NUMBER = "Please enter chassis number";
export const PLEASE_SELECT_EXPIRATION_DATE = "Please select expiration date";
export const VEHICLE_ALREADY_EXISTS = "Vehicle already exists";

export const ARE_YOU_SURE_YOU_WANT_DELETE_ADDRESS =
	"Are you sure you want to delete address ?";

//settings.tsx
export const SETTINGS = "Settings";
export const GENERAL_SETTINGS = "General Settings";
export const REMINDERS = "Reminders";
export const NOTIFICATIONS = "Notifications";
export const HELP_AND_SUPPORT = "Help & Support";

//helpAndSupport.tsx
export const FAQs = "FAQ'S";
export const CONTACT_US = "Contact Us";
export const CHAT_WITH_US = "Chat With us";
export const CALL_US = "Call us";

//bookservice.tsx
export const ADD = "ADD";
export const ESTIMATED_COST = "Estimated Cost";
export const RECOMMENDED = "Recommended";
export const PLEASE_SELECT_IMAGE_DOCUMENT = "Please select front image of document";
export const PLEASE_SELECT_BACK_IMAGE_DOCUMENT = "Please select back image of document";
export const ARE_YOU_SURE_YOU_WANT_DELETE_VEHICLE =
	"Are you sure you want to delete vehicle details ?";

export const PLEASE_ENTER_NICK_NAME = "Enter nickname";
export const PLEASE_ENTER_VALID_NICK_NAME = "Please  enter valid nickname";
export const PLEASE_ENTER_VIN_NUMBER = "Please enter vin number";
export const PLEASE_ENTER_VALID_VIN_NUMBER = "Please enter valid vin number";
export const PLEASE_ENTER_REGISTERED_NUMBER = "Please enter registration number";
export const PLEASE_ENTER_VALID_REGISTERED_NUMBER =
	"Please enter valid registration number";
export const PLEASE_ENTER_ODOMETER = "Please enter odometer";
export const PLEASE_ENTER_VALID_ODOMETER = "Please enter valid odometer";
export const PLEASE_ENTER_ENGINE_NUMBER = "Please enter engine number";
export const PLEASE_ENTER_PUCC_NUMBER = "Please enter pucc number";
export const IS_MANDATORY = " is mandatory";

export const CANCEL = "CANCEL";
export const OK = "OK";
export const UPDATE_NOW = "Update Now";
export const REMIND_LATER = "Remind me later";

export const NO_BRANDS_FOUND = "No brands found";
export const NO_MODELS_FOUND = "No models found";
export const NO_VARIANTS_FOUND = "No variants found";
//service_details.tsx
export const WHATS_INCLUDED = "What's included";
export const SERVICE_DETAILS = "Service Details";
export const HELP = "Help";
export const RupeeSymbol = "AED"; // "₹"; // "SAR"; //
export const CUSTOMIZE_YOUR_SERVICE = "Customize your service";
export const ADD_ONS = "Add Ons";
export const OIL_GRADE = "Oil Grade";

export const WORKSHOP_QUALITY = "Workshop Quality";
export const SELECT_WORKSHOP = "Select Workshop";
export const BRAKE_PROBLEM = "Brake Problem";
export const BREAK_INSPECTION_AND_REPAIR = "Break Inspection & Repair";
export const STANDARD = "Standard";
export const NO_OF_USERS_USE_PREMIUM = "345 + Users choose premium";
export const SERVICE_QUALITY_COMPARED_TO_STANDARD =
	"Service time & quality is 60% higher when compared with standard workshops";
export const ADD_TO_CART = "Add to Cart";
export const BOOK_NOW = "Book Now";
export const SELECT_YOUR_PREFERENCE = "Select Your Preference";
export const PRICE_BASED_ON = "Price based on";
export const PRICING = "Pricing";

//Offers
export const OFFERS = "Offers";
export const NEWLY_ADDED = "Newly Added";
export const REFER_AND_EARN = "Refer & Earn";
export const LEARN_MORE = "Learn More";
export const EXPIRED = "Expired";
export const EXPIRED_OFFERS = "Expired Offers";

export const TERMS_AND_CONDITIONS = "Terms & conditions";
export const FLAT_10_OFF = "Flat 10% Off";
export const YOUR_EARNINGS = "Your earnings";
export const FIVE_HUNDRED_POINTS = " Points";
export const SHARE_YOUR_REFFERRAL_CODE = "Share your referral code";
export const REFERAL_CODE = "auto1xx32";
export const APPLY_REFERRAL_CODE = "Apply Referral Code";
export const HAVE_YOU_REFFERAL_CODE = "Have a referral code? Redeem Here";
export const REDEEM = "Redeem";
export const OFFERS_DETAILS = "Offer Details";
export const TERMS_CONDTIONS_ONE = "1.Get 10% off on all your service bookings";
export const TERMS_CONDTIONS_TWO = "2.Valid on standard pricing";
export const TERMS_CONDTIONS_THREE = "3.Valid on Web, App & M.Web";
export const TERMS_CONDTIONS_FOUR =
	"4.Minimum booking amount is Rs.4,000 5. Maximum discount of Rs.1000 can be availed 6. Offer is valid till 31 dec 2020 ";

export const REFER_TERMS_CONDTIONS_ONE = "1. Invite your friends and get 100 points";
export const REFER_TERMS_CONDTIONS_TWO =
	"2. Referee should click on shared invite & create an account and book a service";
export const REFER_TERMS_CONDTIONS_THREE =
	"3. Referee should transact within 30 days of being referred ";
export const REFER_TERMS_CONDTIONS_FOUR = "4. This offer is valid on Web, App & M.Web";
export const REFER_TERMS_CONDTIONS_FIVE =
	"5. Maximum coins of 500 can be earned by a user";

//Confirmation.tsx
export const CONFIRMATION = "Confirmation";
export const ADVANCE_PAYMENT = "Advance Payment";
export const PAYMENT = "Payment";
export const SERVICE_NOTES = "Service Notes";
export const PICK_DATE = "Pick Date & Time";
export const PICK_DROP = "Pickup & Drop Instructions";
export const OPTIONAL = " (Optional)";
export const PICKER_ERROR = "Please pick date and time";
export const SELECT_FROM_MAP = "Select from MAP";
export const ALERT_MSG =
	"Are you sure want to change your vehicle? current services added to cart will be lost";
export const MY_LOCATION = "My Location : ";
//Cart

export const BREAK_PROBLEM = "Break Problem";
export const CUSTOMIZE = "Customize";
export const ADD_IMAGES = "Add Images";
export const ADD_MORE_SERVICES = "Add More Services";
export const APPLY_COUPON = "Apply Coupon";
export const BILL_DETAILS = "Bill Details";
export const TWO_SERVICES = " Service";
export const ADDED = "Added";
export const SERVICE_TOTAL = "Service Total";
export const INCL_TAXES = "Incl.Taxes";
export const EXCL_TAXES = "Excl.Taxes";
export const FIVE_HUNDRED = "500";
export const COUPON_DISCOUNT = "Coupon Discount";
export const TOTAL_ESTIMATED = "Total Estimated";
export const REFER_YOUR_FRIENDS =
	"Refer your friends & get instant discounts on your bookings";
export const APPLIED_COUPON = "On average users save upto 30% using coupons";
export const PRICE_BASED_ON_STANDARD_PRICING = "Price based on standard pricing";
export const FOUR_HUNDRED_FIFTY = "450";
export const CONFIRM_BOOKING = "Confirm Booking";

// bookingDetails.tsx
export const CLICK_FOR_STATUS = "Click for Status";

//bodyPanel.tsx
export const DAMAGE_SELECTION = "Damage Selection";
export const SELECT_HOTSPOT = "Select Hotspots";
export const TAP_ON_THE_HOTSPOTS_TO_VIEW_SERVICES =
	"Tap on the hotspots to view services";
export const SELECT_SERVICE = "Select Service";
export const FRONT_BUMPER_SELECTED = "Front Bumper Selected";
export const APPLY_PROMO_CODE = "Apply Promo Code";
export const ENTER_COUPON_CODE = "Enter coupon code";
export const APPLY = "Apply";
export const AVAILABLE_COUPONS = "Available coupons";
export const EXPIRED_COUPONS = "Expired";
export const PLEASE_UPLOAD_VALID_FORMAT = "Please upload valid format";

export const SERVICE_ALREADY_ADDED = "Service already added";
export const CHANGE_VEHICLE = "Change Vehicle";
export const CHANGE_VEHICLE_CONFIRM = "Are you sure you want to change your vehicle ?";
export const SERVICES_WILL_LOST = "current services added to cart will be lost";
export const YES = "Yes";
export const NO = "No";
export const BOOKING_CONFIRMED = "Booking Confirmed";
export const BOOKING_CANCELLED = "Booking Cancelled";
export const SEND_GARAGE_ADD =
	"We will send the garage address after it’s assigned within few hours";
export const AUTOROX_EXECUTIVE =
	"Autorox executive will come and pick your vehicle from your loction.";
export const OUR_EXECUTIVE =
	"Our executive will come and pick your vehicle from your loction.";
export const BOOKING_CANCELLED_SUMMARY =
	'On your request, "we are cancelling your booking as the garage has not been allocated"';
export const BOOKING_ID = "Booking Id : ";
export const ASK_QUERIES = "Any queries? Contact us";
export const BOOKING_DETAILS = "Booking Details";
export const ADDON = "Addon :";
export const RESCHEDULE = "Reschedule";
export const SEPARATOR = "|";
export const BD_CANCEL = "Cancel";
export const PRE_PAYMENT = "Pre Payment";
export const SERVICE_MODE = "Service Mode:";
export const PICKUP_LOC = "Pickup Location:";
export const DROP_LOC = "Drop Location:";
export const PICKUP_DROP_INS = "Pickup and Drop Instructions";
export const SERVICE_TIMELINE = "Service Timeline";
export const BOOKING_HISTORY = "Booking History";
export const GIVE_FEEDBACK = "Give Feedback";
export const COMPLETED = "Completed";

export const IMAGES_ADDED = "Images Added";

export const REMOVE = "Remove";

export const DELETE_VEHICLE = "Delete Vehicle";

export const DELETE_ADDRESS = "Delete Address";

export const AGE_SHOULD_BE_GREATER_THAN_18 = "Age should be greater than 18";

export const UNIQUE_ADDRESS_TYPE = "Address type should be unique";

export const DENIED = "denied";
export const GRANTED = "granted";
export const VIEW_CART = "View Cart";

export const PAYMENT_PENDING = "Payment Pending";
export const PAY_NOW = "Pay Now";
export const CLICK_ON_CHAT_OPTIONS =
	"Click on the chat options to get your queries addressed instantly";
export const MAKE_CALL_TO_CUS = "Make calls to get in touch with our customer service";
export const REWARD_POINTS = "Reward Points";

export const NAME_SHOULD_BE_MIN_3_CHAR = "Name should have minimum 3 characters";
export const VIEW_FEEDBACK = "Feedback";
export const HOW_WAS_THE_SERVICE = "How was the service ?";
export const PLEASE_SHARE_FEEDBACK = "Please share your feedback ";

export const CONTACT_US_MOBILE = "9652745816";
export const VEHICLE_ADDED_SUCCESSFULLY = "Vehicle saved successfully";

export const DYNAMIC_LINK = "https://autorox.page.link/SiJ8";
export const UPDATE = "Update";

export const ABOUT_US_LINK = "https://www.autorox.co/about-us/";
export const ABOUT_US_TSERV_LINK = "https://carguys.ae/about-us/"; //"https://www.tserv.in/faqs/";
export const TC_TSERV_LINK = "https://carguys.ae/terms-and-conditions/";
export const PP_TSERV_LINK = "https://carguys.ae/privacy-policy/"; //"https://tserv.in/terms-and-conditions/";
